<template>
  <b-container fluid>
    <b-row>
      <b-col>
        <div class="iq-card p-3 row">
          <div class="col-12 col-sm-6 col-md-6 col-lg-6">
            <h4>
              <i class="fa-solid fa-money-check-dollar" aria-hidden="true" style="font-size: 21px; margin-right: 3px; color: var(--iq-primary);"></i>&nbsp;
              {{cvCardTitle}}
            </h4>
          </div>
        </div>
        <div class="iq-card p-3 h-100 row min-vh-100">
          <div class="col-12">
            <b-tabs
              v-model="activeTab"
              content-class="mt-3"
              align="center"
            >
              <!-- View Single Payment -->
              <b-tab title="View Single Payment" :title-link-class="tabClass(0)">
                <div class="razorpay-payment-form px-3 py-3">
                  <label class="d-block mb-2">Search Payment by Payment ID</label>
                  <div class="d-flex align-items-center">
                    <input style="border: 1px solid #ced4da !important" class="form-control" v-model="searchedPaymentId" type="text" placeholder="Enter Payment Id" />
                    <b-button class="ml-3" variant="primary" @click="getSinglePayment" :disabled="isLoading">
                      <b-spinner v-if="isLoading" small class="mr-1" label="Loading"></b-spinner>
                      {{ isLoading ? "Searching..." : "Search" }}
                    </b-button>
                  </div>
                  <div v-if="errorMessage?.searchedPaymentId" class="text-danger">
                    {{ errorMessage?.searchedPaymentId }}
                  </div>
                </div>
                <div class="iq-card row p-3 mt-3">
                  <b-col class="container_minheight" md="12" v-if="paymentDetails && paymentDetails.length > 0">
                    <b-table
                      hover
                      responsive
                      :items="paymentDetails"
                      :fields="columns"
                      :no-border-collapse="true"
                      >
                      <template v-slot:cell(user_id)="data">
                        <p v-html="data.item.user_id" class="threeLineOnly vhtmlTag vueHtmlParent">
                        </p>
                      </template>
                      <template v-slot:cell(user_email)="data">
                        <p v-html="data.item.user_email" class="threeLineOnly vhtmlTag vueHtmlParent">
                        </p>
                      </template>
                      <template v-slot:cell(pay_status)="data">
                        <div style="gap: 8px;" class="d-flex align-items-center">
                          <b-badge :variant="getStatusVariant(data.item.pay_status)"
                            pill
                            class="px-2 py-1 text-capitalize"
                          >
                            {{ data.item.pay_status }}
                          </b-badge>
                          <i title="Created → Authorized → Captured | Failed / Refunded" class="fa-solid fa-circle-info ml-2 fa-lg pointer text-primary"></i>
                        </div>
                        <b-button v-if="data.item.pay_status === 'authorized'" :disabled="capturingPaymentId === data.item.pay_tid" size="sm" variant="primary" class="primary mx-auto mt-2" @click="capturePayment(data.item)">
                          Capture payment
                        </b-button>
                      </template>
                      <template v-slot:cell(pay_tid)="data">
                        <p v-html="data.item.pay_tid" class="threeLineOnly vhtmlTag vueHtmlParent">
                        </p>
                      </template>
                      <template v-slot:cell(pay_order_id)="data">
                        <p v-html="data.item.pay_order_id" style="word-wrap: break-word">
                        </p>
                      </template>
                      <template v-slot:cell(pay_amount)="data">
                        &nbsp;{{ (data.item.pay_amount) }}
                      </template>
                      <template v-slot:cell(pay_response)="data">
                        <div>
                          <p class="threeLineOnly mb-1">
                            {{ formatResponse(data.item.pay_response) }}
                          </p>
                          <i class="fa-regular fa-copy copy-icon" title="Copy response" @click="copyResponse(data.item.pay_response)"></i>
                        </div>
                      </template>
                      <template v-slot:cell(pay_timestamp)="data">
                        {{data.item.pay_timestamp|dateFormat}}
                      </template>
                    </b-table>
                  </b-col>
                  <b-col v-else-if="isLoading" md="12" class="container_minheight d-flex align-items-center justify-content-center">
                    <div class="text-center">
                      <b-spinner variant="primary" style="width: 3rem; height: 3rem;" label="Loading"></b-spinner>
                      <div class="mt-3 font-weight-semibold text-muted">
                        Fetching payment details…
                      </div>
                    </div>
                  </b-col>
                  <b-col class="container_minheight d-flex align-items-center justify-content-center" md="12" v-else>
                    No data found
                  </b-col>
                </div>
              </b-tab><!-- View Single Payment -->
              <!-- View Payments by Date Range -->

              <b-tab title="View Payments by Date Range" :title-link-class="tabClass(1)">
                <div class="px-3 razorpay-payment-form py-3">
                  <h3 class="py-5 text-center">Please enter an email and select From Date & time. Payments will be searched within a maximum 30-minute window from the selected From Date & time.</h3>
                  <div class="mb-3">
                    <label>Enter the email used for payment</label>
                    <input style="border: 1px solid #ced4da !important" class="form-control col-12 col-md-6" v-model="vmRazorpayPaymentFormData.user_email" type="text" placeholder="Enter User Email" />
                    <div v-if="errorMessage?.user_email" class="text-danger pt-1">
                      {{ errorMessage?.user_email }}
                    </div>
                  </div>
                  <div class="mb-3">
                    <label>From Date & time</label>
                    <datetime
                      type="datetime"
                      v-model="vmRazorpayPaymentFormData.from_date"
                      input-class="gide_datetime_input"
                      class="datetime-theme-primary col-12 col-md-6 px-0"
                      :format="{ year: 'numeric', month: 'long', day: 'numeric', hour: 'numeric', minute: '2-digit'}"
                      :phrases="{ok: 'Continue', cancel: 'Exit'}"
                      :hour-step="1"
                      :minute-step="1"
                      :week-start="7"
                      use12-hour
                      auto
                      :max-datetime="getCurrentDateTime()"
                    ></datetime>
                    <div v-if="errorMessage?.from_date" class="text-danger pt-1">
                      {{ errorMessage?.from_date }}
                    </div>
                  </div>

                  <!-- <div class="mb-3">
                    <label>To Date</label>
                    <datetime
                      type="datetime"
                      v-model="vmRazorpayPaymentFormData.to_date"
                      input-class="gide_datetime_input"
                      class="datetime-theme-primary col-12 col-md-6 px-0"
                      :format="{ year: 'numeric', month: 'long', day: 'numeric', hour: 'numeric', minute: '2-digit'}"
                      :phrases="{ok: 'Continue', cancel: 'Exit'}"
                      :hour-step="1"
                      :minute-step="1"
                      :week-start="7"
                      use12-hour
                      auto
                      :min-datetime="vmRazorpayPaymentFormData.from_date || getCurrentDateTime()"
                      :max-datetime="getCurrentDateTime()"
                    ></datetime>
                    <div v-if="errorMessage?.to_date" class="text-danger pt-1">
                      {{ errorMessage?.to_date }}
                    </div>
                  </div> -->
                  <b-button class="mt-3" variant="primary" @click="getPaymentsByDateRange" :disabled="isLoading">Search</b-button>
                </div>
                <div class="iq-card row p-3 mt-3">
                  <b-col md="12" v-if="paymentsList && paymentsList.length > 0">
                    <b-table
                      hover
                      responsive
                      :items="paymentsList"
                      :fields="columns"
                      :no-border-collapse="true"
                      :current-page="currentPage"
                      :per-page="perPage"
                      >
                      <template v-slot:cell(id)="data">
                        {{ (currentPage - 1) * perPage + data.index + 1 }}
                      </template>
                      <template v-slot:cell(user_id)="data">
                        <p v-html="data.item.user_id" class="threeLineOnly vhtmlTag vueHtmlParent">
                        </p>
                      </template>
                      <template v-slot:cell(user_email)="data">
                        <p v-html="data.item.user_email" class="threeLineOnly vhtmlTag vueHtmlParent">
                        </p>
                      </template>
                      <template v-slot:cell(pay_status)="data">
                        <div style="gap: 8px;" class="d-flex align-items-center">
                          <b-badge :variant="getStatusVariant(data.item.pay_status)"
                            pill
                            class="px-2 py-1 text-capitalize"
                          >
                            {{ data.item.pay_status }}
                          </b-badge>
                          <i title="Created → Authorized → Captured | Failed / Refunded" class="fa-solid fa-circle-info fa-lg pointer text-primary"></i>
                        </div>
                        <b-button v-if="data.item.pay_status === 'authorized'" :disabled="capturingPaymentId === data.item.pay_tid" size="sm" variant="primary" class="primary mx-auto mt-2" @click="capturePayment(data.item)">
                          Capture payment
                        </b-button>
                      </template>
                      <template v-slot:cell(pay_tid)="data">
                        <p v-html="data.item.pay_tid" class="threeLineOnly vhtmlTag vueHtmlParent">
                        </p>
                      </template>
                      <template v-slot:cell(pay_order_id)="data">
                        <p v-html="data.item.pay_order_id" style="word-wrap: break-word">
                        </p>
                      </template>
                      <template v-slot:cell(pay_amount)="data">
                        &nbsp;{{ (data.item.pay_amount) }}
                      </template>
                      <template v-slot:cell(pay_response)="data">
                        <div>
                          <p class="threeLineOnly mb-1">
                            {{ formatResponse(data.item.pay_response) }}
                          </p>
                          <i class="fa-regular fa-copy copy-icon" title="Copy response" @click="copyResponse(data.item.pay_response)"></i>
                        </div>
                      </template>
                      <template v-slot:cell(pay_timestamp)="data">
                        {{data.item.pay_timestamp|dateFormat}}
                      </template>
                    </b-table>
                  </b-col>
                  <b-col style="height: 280px;" v-else-if="isLoading" md="12" class="d-flex align-items-center justify-content-center">
                    <div class="text-center">
                      <b-spinner variant="primary" style="width: 3rem; height: 3rem;" label="Loading"></b-spinner>
                      <div class="mt-3 font-weight-semibold text-muted">
                        Matching transactions with the provided email…
                      </div>
                    </div>
                  </b-col>
                  <b-col style="height: 400px;" class="d-flex align-items-center justify-content-center" md="12" v-else>
                    No data found
                  </b-col>
                  <b-col class="my-4 d-flex align-items-center">
                    <div class="flex-grow-1">
                      <b-button v-if="fetch_from_rzp_api === 1" size="sm" variant="primary" class="primary" @click="getPaymentsByDateRange()">
                        Refresh Results
                      </b-button>
                    </div>
                    <b-col v-if="paymentsList && paymentsList.length > perPage" sm="5" md="4">
                      <b-pagination
                        v-model="currentPage"
                        :total-rows="totalRows"
                        :per-page="perPage"
                        align="fill"
                        size="sm"
                        class="my-0"></b-pagination>
                    </b-col>
                  </b-col>
                </div>
              </b-tab><!-- View Payments by Date Range -->
            </b-tabs>
          </div>
        </div>
      </b-col>
    </b-row>
    <b-toast v-model="showToast" name="Toast" :variant="toastVariant" :title="toastTitle">
      <div v-html="toastMsg"></div>
    </b-toast>
  </b-container>
</template>
<script>
import "vue-datetime/dist/vue-datetime.css"
import { socialvue } from "../../../config/pluginInit"
import { PayTransactionss } from "../../../FackApi/api/PayTransactions"
import { Datetime } from "vue-datetime"
import { PayCache } from "../../../FackApi/api/PayCache"

export default {
  name: "RazorpayPayments",
  components: {
    Datetime
  },
  data () {
    return {
      cvCardTitle: "Razorpay Payments",
      showToast: false,
      toastVariant: "default",
      toastTitle: "Razorpay Payments",
      toastMsg: "",
      activeTab: 0,
      searchedPaymentId: null,
      errorMessage: {
        searchedPaymentId: null,
        user_email: null,
        from_date: null
        // to_date: null
      },
      paymentDetails: [],
      paymentsList: [],
      isLoading: false,
      columns: [
        { label: "# ", key: "id", class: "text-left align-text-top", sortable: true },
        { label: "User Id", key: "user_id", class: "text-left align-text-top w-350px", sortable: true },
        { label: "User Email", key: "user_email", class: "text-left align-text-top w-300px", sortable: true },
        { label: "Status Code", key: "pay_status", class: "text-left align-text-top w-200px", sortable: true },
        { label: "Trans. Id", key: "pay_tid", class: "text-left align-text-top w-200px", sortable: true },
        { label: "Order id", key: "pay_order_id", class: "text-left align-text-top w-200px", sortable: true },
        { label: "Amount (INR)", key: "pay_amount", class: "text-left align-text-top", sortable: true },
        { label: "Razorpay Full Response", key: "pay_response", class: "text-left align-text-top w-200px", sortable: false },
        { label: "Payment Captured time", key: "pay_timestamp", class: "text-left align-text-top w-200px", sortable: true }
      ],
      vmRazorpayPaymentFormData: {
        user_email: null,
        from_date: null
        // to_date: null,
      },
      totalRows: 1,
      currentPage: 1,
      perPage: 25,
      fetch_from_rzp_api: 0, // 0 -> fetch from cache, 1 -> fetch from razorpay api
      capturingPaymentId: null
    }
  },
  mounted () {
    socialvue.index()
    if (this.$route.query.pay_tid) {
      this.searchedPaymentId = this.$route.query.pay_tid
    }
  },
  methods: {
    /**
     * getCurrentDateTime
     * Get current date and time in ISO format
     */
    getCurrentDateTime () {
      return new Date().toISOString()
    },
    /**
     * getSinglePayment
     * Fetch payment by ID
     */
    async getSinglePayment () {
      // Validate input
      if (!this.searchedPaymentId || this.searchedPaymentId.trim() === "") {
        this.errorMessage.searchedPaymentId = "Please enter a Payment ID"
        return
      }

      try {
        this.isLoading = true
        this.errorMessage.searchedPaymentId = null

        const payload = {
          pay_id: this.searchedPaymentId.trim()
        }

        // Call the api with Payment ID
        let paymentResp = await PayTransactionss.razorpay_payment_by_id_view(this, payload)
        if (paymentResp.resp_status) {
          paymentResp.resp_data.data.id = 1 // Set ID to 1 for single record display
          this.paymentDetails = [paymentResp.resp_data.data] || []
        }
        else {
          this.showToast = true
          this.toastVariant = "danger"
          this.toastMsg = "Failed to fetch payment details."
          console.error("Error fetching payment:", paymentResp.error)
          this.paymentDetails = []
        }
      }
      catch (error) {
        this.showToast = true
        this.toastVariant = "danger"
        this.toastMsg = "An error occurred while fetching payment details."
        console.error("Exception in getSinglePayment:", error)
        this.paymentDetails = []
      }
      finally {
        this.isLoading = false
      }
    },
    /* * getPaymentsByDateRange
     * Fetch payments by date range
     * Math.floor(maxToTs / 1000), // Math.floor(Date.now() / 1000), // Math.floor(Math.min(maxToTs, nowTs) / 1000)
     * Use the above values to tweak the "to_date" while fetching payments from Razorpay
     */
    async getPaymentsByDateRange () {
      try {
        // Validate User Email
        if (!this.vmRazorpayPaymentFormData.user_email && this.vmRazorpayPaymentFormData.user_email.trim() === "") {
          this.errorMessage.user_email = "Please enter an email address."
          return
        }
        if (this.vmRazorpayPaymentFormData.user_email) {
          const userEmail = this.vmRazorpayPaymentFormData.user_email.trim()
          const emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/
          if (!emailPattern.test(userEmail)) {
            this.errorMessage.user_email = "Please enter a valid email address."
            return
          }
        }

        // Validate From Date date
        if (!this.vmRazorpayPaymentFormData.from_date) {
          this.errorMessage.from_date = "Please select 'From Date'."
          return
        }

        // Validate To Date date
        // if (!this.vmRazorpayPaymentFormData.to_date) {
        //   this.errorMessage.to_date = "Please select 'To Date'."
        //   console.log("Please select 'To Date'.")
        //   return
        // }

        // const fromDate = new Date(this.vmRazorpayPaymentFormData.from_date)
        // const toDate = new Date(this.vmRazorpayPaymentFormData.to_date)
        // Validate that to_date is after from_date
        // if (toDate < fromDate) {
        //   this.errorMessage.to_date = "'To Date' must be after 'From Date'."
        //   console.log("'To Date' must be after 'From Date'.")
        //   return
        // }
        // Validate that to_date is not in the future
        // if (toDate > new Date()) {
        //   this.errorMessage.to_date = "'To Date' cannot be in the future."
        //   return
        // }

        // Clear previous errors
        // this.errorMessage.to_date = null
        this.errorMessage.from_date = null
        this.errorMessage.user_email = null

        this.isLoading = true

        // this.vmRazorpayPaymentFormData.from_date => "2025-12-23T03:35:00.000Z" UTC time in string data type
        const fromDate = new Date(this.vmRazorpayPaymentFormData.from_date) // "Tue Dec 23 2025 09:05:00 GMT+0530 (India Standard Time)"

        const fromTs = fromDate.getTime() // 1766460900000 in miliseconds
        const maxToTs = fromTs + 30 * 60 * 1000 // "fromTs" + 30 minutes in ms

        const nowTs = Date.now() // current timestamp in miliseconds
        // If from_date is 12:00pm, adding 30 mins makes it 12:30pm but if current time is 12:15pm then to_date is a date in future, so take the min between maxToTs & nowTs
        const toDate = Math.floor(Math.min(maxToTs, nowTs) / 1000)

        const payload = {
          user_email: this.vmRazorpayPaymentFormData.user_email?.trim() || null,
          from_date: Math.floor(fromTs / 1000),
          to_date: toDate,
          fetch_from_rzp_api: this.fetch_from_rzp_api
        }

        // Call the API to fetch payments by date range
        const paymentsResp = await PayTransactionss.razorpay_payments_by_timestamp_list(this, payload)

        if (paymentsResp.resp_status) {
          if (Array.isArray(paymentsResp?.resp_data?.items)) {
            // Add newly fetched payments while preventing duplicates when user has requested to "refresh results", reset the list when search parameters change
            const existingIds = new Set(this.paymentsList.map(p => p.pay_tid))
            const newItems = paymentsResp.resp_data.items.filter(p => p?.pay_tid && !existingIds.has(p.pay_tid))
            if (this.paymentsList.length > 0 && newItems.length > 0 && newItems[0]?.user_email === this.paymentsList[this.paymentsList.length - 1]?.user_email) {
              this.paymentsList.push(...newItems)
            }
            else if (newItems.length > 0) {
              this.paymentsList = [...newItems]
            }
            else {
              this.toastVariant = "danger"
              this.toastMsg = "No new Payment found since last fetched"
              this.showToast = true
            }
          }
          this.totalRows = this.paymentsList.length ?? 1
          this.fetch_from_rzp_api = paymentsResp.resp_data.response_from_cache ? 1 : 0
        }
        else {
          this.toastVariant = "danger"
          this.toastMsg = "Failed to fetch payments."
          this.paymentsList = []
          console.error("Error fetching payments:", paymentsResp)
          this.showToast = true
        }
      }
      catch (error) {
        this.showToast = true
        this.toastVariant = "danger"
        this.toastMsg = "An error occurred while fetching payments."
        this.paymentsList = []
        console.error("Exception in getPaymentsByDateRange:", error)
      }
      finally {
        this.isLoading = false
      }
    },
    /**
     * tabClass
     */
    tabClass (index) {
      return this.activeTab === index ? "font-weight-bold text-primary" : ""
    },
    /**
     * getStatusVariant
     */
    getStatusVariant (status) {
      switch ((status || "").toLowerCase()) {
        case "captured":
          return "success" // green
        case "authorized":
          return "warning" // yellow
        case "created":
          return "secondary" // gray
        case "failed":
          return "danger" // red
        case "refunded":
          return "info" // blue
        default:
          return "dark"
      }
    },
    /**
     * formatResponse
     */
    formatResponse (response) {
      try {
        return JSON.stringify(JSON.parse(response), null, 2)
      }
      catch (e) {
        return response
      }
    },
    /**
     * copyResponse
     */
    copyResponse (response) {
      if (!response) return

      let textToCopy = response

      try {
        // Pretty-print JSON before copying
        textToCopy = JSON.stringify(JSON.parse(response), null, 2)
      }
      catch (e) {
        // fallback if not valid JSON
        textToCopy = response
      }

      navigator.clipboard.writeText(textToCopy)
        .then(() => {
          console.log("Payment response copied")
        })
        .catch(err => {
          console.error("Copy failed", err)
        })
    },
    /**
     * capturePayment
     */
    async capturePayment (payment) {
      try {
        let formattedResponse = {}
        try {
          formattedResponse = JSON.parse(payment.pay_response)
        }
        catch (e) {
          console.error("Error parsing pay_response:", e)
        }

        if (!payment || payment.pay_status?.toLowerCase() !== "authorized" || !payment.pay_tid || !formattedResponse?.currency) {
          this.showToast = true
          this.toastVariant = "danger"
          this.toastMsg = "Something went wrong."
          return
        }
        this.capturingPaymentId = payment.pay_tid

        let paySubsId = null
        if (formattedResponse.notes?.pay_subs_id) {
          paySubsId = formattedResponse.notes.pay_subs_id
        }
        else if (formattedResponse.notes?.product) {
          paySubsId = formattedResponse.notes.product
        }

        const capturePaymentPayload = {
          update_status_authorize_to_captured: true,
          pay_tid: payment.pay_tid,
          amount: payment.pay_amount,
          currency: formattedResponse?.currency,
          user_name: formattedResponse.notes.student_name ?? formattedResponse.email?.split("@")[0],
          user_email: formattedResponse.email,
          user_mobile: formattedResponse.contact,
          gide_user_id: formattedResponse.user_id,
          pay_order_id: formattedResponse.order_id,
          pay_subs_id: paySubsId
        }
        const captureResp = await PayCache.pay_cache_edit(this, capturePaymentPayload)
        if (captureResp.resp_status) {
          this.showToast = true
          this.toastVariant = "success"
          this.toastMsg = "Payment captured successfully."

          // Refresh the payment details
          if (this.activeTab === 0) {
            this.getSinglePayment()
          }
          else if (this.activeTab === 1) {
            this.getPaymentList()
          }
        }
        else {
          this.showToast = true
          this.toastVariant = "danger"
          this.toastMsg = "Failed to capture payment."
          console.error("Error capturing payment:", captureResp.error)
        }
      }
      catch (error) {
        this.showToast = true
        this.toastVariant = "danger"
        this.toastMsg = "An error occurred while capturing payment."
        console.error("Exception in capturePayment:", error)
      }
      finally {
        this.capturingPaymentId = null
      }
    }
  },
  watch: {
    /**
     * Watch activeTab for changes
     * Clear error messages and remove form data when tab switches
     */
    activeTab (newVal) {
      this.errorMessage = {
        searchedPaymentId: null,
        user_email: null,
        from_date: null
        // to_date: null
      }

      // Also clear form data on tab switch
      // this.searchedPaymentId = null
      // this.vmRazorpayPaymentFormData = {
      //   user_email: null,
      //   from_date: null,
      //   to_date: null
      // }

      // Clear payment details on tab switch
      // this.paymentDetails = []

      // Clear payments list on tab
      // this.paymentsList = []

      // Clear capturingPaymentId on tab switch
      this.capturingPaymentId = null

      // loading false
      this.isLoading = false
    },
    /**
     * Watch searchedPaymentId for changes
     * Clear error when user types
     */
    searchedPaymentId (newVal) {
      if (newVal) {
        this.errorMessage.searchedPaymentId = null
      }
    },
    /**
     * Watch entire vmRazorpayPaymentFormData object for changes
     * Clear corresponding errors when fields change
     */
    vmRazorpayPaymentFormData: {
      handler (newVal) {
        if (newVal.user_email) {
          this.errorMessage.user_email = null
          this.fetch_from_rzp_api = 0
        }
        if (newVal.from_date) {
          this.errorMessage.from_date = null
          this.fetch_from_rzp_api = 0
        }
        // if (newVal.to_date) {
        //   this.errorMessage.to_date = null
        // }
      },
      deep: true // Required to watch nested object properties
    }
  }
}
</script>
<style>

  /* Add required symbol (*) to all labels in razorpay-payment-form */
  .razorpay-payment-form label {
    font-weight: 500;
  }

  .razorpay-payment-form label::after {
    content: " *";
    color: red;
    font-weight: bold;
  }
  .copy-icon {
    cursor: pointer;
    margin-left: 8px;
    font-size: 14px;
    color: #6c757d;
  }

  .copy-icon:hover {
    color: var(--iq-primary);
  }
</style>
